export const MODULE_NAME = 'digital-payments-travel-wishlist-root';
export const DEFAULT_ANALYTICS_PAGE_VIEW = 'WishlistBuilder|';

export const IDLE = 'idle';
export const LOADING = 'loading';
export const ERROR = 'error';
export const SUCCESS = 'success';

export const GENERAL = 'general';
export const NOTELIGIBLE = 'notEligible';
